import React from "react";
import {
  Sun,
  Cog,
  Network,
  Building2,
  HeartPulse,
  Truck,
  Droplets,
  Factory,
} from "lucide-react";

const SECTORS = [
  {
    key: "renewable",
    title: "Renewable Energy & Grid",
    icon: Sun,
    img: "https://images.unsplash.com/photo-1674606071893-2a9023075f70?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxzb2xhciUyMHBhbmVscyUyMGRlc2VydHxlbnwwfHx8fDE3ODM2NzIzNTF8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "automation",
    title: "Industrial Automation",
    icon: Cog,
    img: "https://images.unsplash.com/photo-1655393001768-d946c97d6fd1",
  },
  {
    key: "digital",
    title: "Digital Infrastructure & AI",
    icon: Network,
    img: "https://images.unsplash.com/photo-1513061379709-ef0cd1695189?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxzbWFydCUyMGNpdHklMjBuZXR3b3JrfGVufDB8fHx8MTc4MzY3MjM1MXww&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "smart-cities",
    title: "Smart Cities & Real Estate",
    icon: Building2,
    img: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&q=80",
  },
  {
    key: "healthcare",
    title: "Healthcare Technology",
    icon: HeartPulse,
    img: "https://images.unsplash.com/photo-1580281657527-47f249e8f4df?auto=format&fit=crop&w=1200&q=80",
  },
  {
    key: "logistics",
    title: "Logistics & Supply Chain",
    icon: Truck,
    img: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=1200&q=80",
  },
  {
    key: "water",
    title: "Water & Sustainability",
    icon: Droplets,
    img: "https://images.unsplash.com/photo-1548407260-da850faa41e3?auto=format&fit=crop&w=1200&q=80",
  },
  {
    key: "manufacturing",
    title: "Manufacturing & Localization",
    icon: Factory,
    img: "https://images.unsplash.com/photo-1565043666747-69f6646db940?auto=format&fit=crop&w=1200&q=80",
  },
];

export default function Sectors() {
  return (
    <section
      id="sectors"
      data-testid="sectors-section"
      className="relative bg-white py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <div className="overline mb-5">Where we operate</div>
            <h2 className="font-display text-4xl md:text-5xl font-medium text-[#0A1128] tracking-tight leading-[1.05]">
              Sectors we serve.
            </h2>
          </div>
          <p className="text-slate-600 max-w-md text-base">
            High-conviction, high-impact industries at the intersection of energy, technology and
            localization — from renewable grid to healthcare tech.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SECTORS.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.key}
                data-testid={`sector-card-${s.key}`}
                className="group relative overflow-hidden rounded-2xl border border-slate-200 card-lift bg-white"
              >
                <div className="relative aspect-[4/5] overflow-hidden">
                  <img
                    src={s.img}
                    alt={s.title}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A1128] via-[#0A1128]/40 to-transparent" />
                  <div className="absolute top-4 left-4 w-10 h-10 rounded-lg bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center">
                    <Icon className="w-4 h-4 text-white" />
                  </div>
                  <div className="absolute bottom-4 left-4 right-4">
                    <div className="text-[10px] uppercase tracking-widest text-[#00D084] font-semibold mb-2">
                      0{i + 1}
                    </div>
                    <div className="font-display text-white text-xl md:text-2xl font-medium leading-tight tracking-tight">
                      {s.title}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
